import { AloftArea, AloftPrice, schAloftArea } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectOpinionOfSiteValuePrice } from './opinionOfSiteValueSelectors.ts';
import { selectSiteEntities } from './propertyDataSelectors/siteSelectors.ts';

const selectOpinionOfSiteValuePerSF = createSelector(
  [selectOpinionOfSiteValuePrice, selectSiteEntities],
  (opinionOfSiteValuePrice, sites) => {
    const { subject } = sites;

    if (!subject || !opinionOfSiteValuePrice) return undefined;

    const siteArea = schAloftArea.safeParse(subject.area);
    if (!siteArea.success || siteArea.data.equals(AloftArea.zero)) return AloftPrice.zero;

    return opinionOfSiteValuePrice.div(siteArea.data.getUnitAmount('sqft'));
  },
);

export const selectOpinionOfSiteValuePerSFDisplay = createSelector(
  [selectOpinionOfSiteValuePerSF],
  (perSF) => perSF?.toDollarLike().toString() ?? '',
);
